import type { CardContentMaxWidth } from '@/lib/types';
import { theme } from '@/theme/getTheme';

export const getDeskTopMaxContentWidth = (
  type: string,
  contentMaxWidth?: CardContentMaxWidth,
) => {
  const desktopMaxWidth = theme.components.cmsCard.content.desktopMaxWidth;
  if (contentMaxWidth === 'large') return desktopMaxWidth.Md;
  switch (type) {
    case 'MediaBanner':
      return desktopMaxWidth.MediaBannerOrMediaAndBottomText;
    case 'MediaAndBottomText':
      return desktopMaxWidth.MediaBannerOrMediaAndBottomText;
    case 'SectionBanner':
      return desktopMaxWidth.MediaAndSideTextOrSectionBanner;
    case 'MediaAndSideText':
      return desktopMaxWidth.MediaAndSideTextOrSectionBanner;
    default:
      return desktopMaxWidth.Default;
  }
};
